import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  createTimedEventProductTags,
  getTagsInProductTags,
  getTimedEventsProductTags,
} from "../../services/timedEventsProductTagsService";

const AppliesOnProductTagsModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const tags = useSelector((state) => state.timedEventsProductTags);

  useEffect(() => {
    dispatch(getTagsInProductTags(id.id));
  }, [dispatch, id.id]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.timedEvents.edit_tags")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.ProductTags = values.ProductTags?.map((el) => ({
                ProductTagId: el.TagId,
              }));
              values.TimedEventId = id.id;
              values.UserId = localStorage.getItem("userId");
              if (
                values.ProductTags === undefined ||
                values.ProductTags?.length === 0
              ) {
                toast2({
                  description: t("validation.required"),
                });
              } else {
                dispatch(createTimedEventProductTags(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t(
                        "pages.timedEvents.product_tag_timed_event_created"
                      ),
                    });
                    dispatch(getTimedEventsProductTags(id.id));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("pages.tags.tags")}
                data={
                  Array.isArray(tags.tagsInProductTag)
                    ? tags.tagsInProductTag.map((el) => ({
                        ...el,
                        label: el.TagName,
                        value: el.TagId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("ProductTags", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={tags.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={tags.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AppliesOnProductTagsModal;
